export const CONFIG_CDN_URL = 'https://lnesv3-conf.ado-tech.com';

export const PLATFORMS = {
    IOS: 'ios',
    ANDROID: 'android',
    REACT_NATIVE: 'react-native',
    WEB: 'web'
};

export const MESSAGE_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error-intern'
};

export const STATUS = {
    SUCCESS: 'success',
    BACK: 'back'
};
